<template>
  <div>
    <LoadingIndicator v-if="!products" />
    <ProductFilterBar class="p-3" @search="filterProducts" @reset="resetFilter" />
    <div class="grid-container">
      <el-card
        v-for="product in currentDataset"
        :key="product.id"
        class="p-3 mt-3 item-card d-flex align-items-center justify-content-center"
        @click.native="goToProduct(product.get('modxId'))"
      >
        <div>{{ product.get('name') }}</div>
        <div>
          <el-tag v-for="group in product.get('groups')" :key="group.id" class="m-1" size="mini">
            {{ group.get('name') }}
          </el-tag>
        </div>
        <div v-if="product.get('attributes')" class="font-weight-light mt-4">
          {{
            product
              .get('attributes')
              .map((el) => el.get('name'))
              .join(', ')
          }}
        </div>
      </el-card>
    </div>
    <NoResults v-if="currentDataset.length === 0 && showSearchResults" :text="$t('general.no_result')" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';
import LoadingOverlay from '../../components/loading/LoadingOverlay';
import LoadingIndicator from '../../components/loading/LoadingIndicator';
import ProductFilterBar from './components/ProductFilterBar';
import NoResults from '../../components/NoResults';

export default {
  name: 'ProductsView',
  components: { NoResults, ProductFilterBar, LoadingIndicator },
  props: {},
  mounted() {
    this.loadProducts();
  },
  destroyed() {},
  data() {
    return {
      showSearchResults: false,
      filteredData: [],
    };
  },
  computed: {
    ...mapGetters(StoreModules.PRODUCTS, ['products']),
    currentDataset() {
      if (this.showSearchResults) return this.filteredData;
      else return this.products;
    },
  },
  methods: {
    ...mapActions(StoreModules.PRODUCTS, ['loadProducts']),
    filterProducts(filter) {
      let query = { search: JSON.stringify(filter) };

      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.push({ name: this.$route.routeName, query });
      }

      if (!this.products) return;

      let pp = this.products;

      if (filter.term) {
        pp = this.products.filter((el) => {
          if (filter.term) {
            return el
              .get('name')
              .replace(/-/, ' ')
              .toLowerCase()
              .includes(filter.term.replace(/-/, ' ').toLowerCase());
          }
          return false;
        });
      }

      //FILTER ATTRIBUTES
      if (filter.attributes && filter.attributes.items.length > 0)
        pp = pp.filter((el) => {
          let a = filter.attributes.items;

          let r = 0;

          if (!el.get('attributes')) return false;

          for (let i = 0; i < a.length; i++) {
            if (
              el
                .get('attributes')
                .map((m) => m.id)
                .includes(a[i])
            )
              r++;
          }
          if (filter.attributes.type === 'or') {
            return r > 0;
          } else {
            return r === a.length;
          }
        });

      //FILTER GROUPS
      if (filter.groups && filter.groups.items.length > 0) {
        pp = pp.filter((el) => {
          let a = filter.groups.items;

          let r = 0;

          if (!el.get('groups')) return false;

          for (let i = 0; i < a.length; i++) {
            if (
              el
                .get('groups')
                .map((m) => m.id)
                .includes(a[i])
            )
              r++;
          }
          if (filter.groups.type === 'or') {
            return r > 0;
          } else {
            return r === a.length;
          }
        });
      }

      this.filteredData = pp;
      this.showSearchResults = true;
    },
    resetFilter() {
      this.filteredData = [];
      this.showSearchResults = false;
      this.$router.push({ name: this.$route.routeName, query: null });
    },
    goToProduct(id) {
      this.$router.push({ name: 'ProductViewRoute', params: { id: parseInt(id) } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors.scss';
</style>
